export default __webpack_public_path__ + "352645082c7f98bf0135b2c7058df520.png";